import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { selectActiveCompanyId } from "../../../redux/features/user/selectors/userState.selectors";
import { getEventDeliveryApiKey } from "../actions/getEventDeliveryApiKey";
import { getEventDeliverySigningSecret } from "../actions/getEventDeliverySigningSecret";
import { rollEventDeliverySigningSecret } from "../actions/rollEventDeliverySigningSecret";
import { EVENT_DELIVERY_CONFIG_QUERY_KEY } from "./useGetEventDeliveryConfig";

export const useRevealEventDeliveryApiKey = () => {
  return useMutation({
    mutationFn: () => getEventDeliveryApiKey(),
  });
};

export const useRevealEventDeliverySigningSecret = () => {
  return useMutation({
    mutationFn: () => getEventDeliverySigningSecret(),
  });
};

export const useRollEventDeliverySigningSecret = () => {
  const queryClient = useQueryClient();
  const companyId = useSelector(selectActiveCompanyId);

  return useMutation({
    mutationFn: () => rollEventDeliverySigningSecret(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [EVENT_DELIVERY_CONFIG_QUERY_KEY, companyId] });
    },
  });
};
